<template>
    <label :class="{ switch: true, on: boundValue, disabled: disabled }">
        <span class="label-text">{{ label }}</span>
        <div class="switch-toggle">
            <input type="checkbox" v-model="boundValue" :disabled="disabled" />
            <div class="surface"></div>
            <div class="knob"></div>
        </div>
    </label>
</template>
<script>
export default {
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
}
</script>
<script setup>
import { computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    modelValue: {
        type: Boolean,
    },
})

const emit = defineEmits(['update:modelValue'])

const boundValue = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    },
})
</script>
<style scoped>
.switch {
    --surface-height: 14px;
    --surface-width: 34px;
    --knob-height: 20px;

    cursor: pointer;
    height: var(--input-height);
    margin-bottom: var(--spacing-2);
    padding-right: var(--surface-width);
    position: relative;
}

.label-text {
    line-height: 40px;
    margin-right: var(--spacing-2);
    white-space: nowrap;
}

.switch-toggle {
    position: absolute;
    right: 0;
    top: 0;
    height: var(--input-height);
    width: var(--input-height);
}

input[type='checkbox']::before {
    display: none !important;
}

.surface {
    background-color: rgba(80, 79, 84, 0.1);
    height: var(--surface-height);
    width: var(--surface-width);
    border-radius: calc(var(--surface-height) / 2);
    position: absolute;
    top: calc((var(--input-height) - var(--surface-height)) / 2);
    left: calc((var(--input-height) - var(--surface-width)) / 2);
}

.knob {
    height: var(--knob-height);
    width: var(--knob-height);
    border-radius: calc(var(--knob-height) / 2);
    background-color: #fafafa;

    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    top: calc((var(--input-height) - var(--knob-height)) / 2);
    left: calc((var(--input-height) - var(--surface-width)) / 2);

    &:hover::before {
        display: block;
        position: absolute !important;
        content: '';
        height: var(--input-height);
        width: var(--input-height);
        border-radius: calc(var(--input-height) / 2);
        background-color: rgba(0, 0, 0, 0.04);
        top: calc((var(--input-height) - var(--knob-height)) / -2);
        left: calc((var(--input-height) - var(--knob-height)) / -2);
    }
}

.switch.on {
    & .surface {
        background-color: var(--color-switch-on);
    }

    & .knob {
        left: auto;
        right: calc((var(--input-height) - var(--surface-width)) / 2);
    }
}
</style>
